// Routes.js
const Routes = {
    home: {
        main: '/',
        basketDetails: '/basket-details/:id',
        basketwithdrawbalance: '/basket-details/:id/withdraw-fund',
        basketCreate: '/create-basket',
        basketUpdate: '/update-basket/:id',
    },
    parishes: {
        main: '/parishes',
        organizationDetails: '/parishes/organization-details/:companyId',
    },
    staff: {
        main: '/staff',
        details: '/staff/:username',
        add: '/staff/add',
    },
    account: {
        main: '/my-account',
        edit: '/my-account/edit',
        changePhoto: '/my-account/change-photo',
        changePassword: '/my-account/change-password',
    },
    community: {
        main: '/community',
        ParishonerDetails: '/community/parishoner-detail/:uuid',
        issueRefund: '/community/parishoner-detail/transaction-detail/issue-refund/:id',
    },
    wallet: {
        main: '/wallet',
        parishWallet: '/wallet/parish-wallet',
        withdrawToBank: '/wallet/parish-wallet/withdraw-to-bank',
        givingBasket: '/wallet/giving-basket',
        paymentBasket: '/wallet/payment-basket',
        invoiceDetails: '/wallet/invoice-details/:id',
        /** Phase 11 Ready — Stripe Connect onboarding/status only. */
        stripeSetup: '/wallet/stripe-setup',
    },
    announcements: {
        main: '/announcements',
        details: '/announcements/details/:id',
        new: '/announcements/new-announcements',
        edit: '/announcements/edit/:id',
        createGroup: '/announcements/create-group',
        groupDetails: '/announcements/group-details/:id',
    },
    sendinvoice: {
        main: '/send-invoice',
    },
    /** Parish invoice history — lives under Wallet (`/wallet/invoices`). */
    invoices: {
        list: '/wallet/invoices',
    },
    /** Canonical payment-request detail — matches backend email link path. */
    paymentRequests: {
        detail: '/payment-requests/:id',
    },
    sendmoney: {
        main: '/send-money',
    },
    auth: {
        login: '/login',
        register: '/auth/register',
        forgotPassword: '/auth/forgot-password',
        verifyPin: '/auth/verify-pin',
        verifyEmail: '/auth/verify-email-pin',
        verify2fa: '/auth/verify-2fa',
        acceptMemberInvite: '/accept-member-invite',
        acceptInvite: '/accept-invite',
    },
    qr: {
        main: '/qr/view-qr',
    },
    /** Parish ledger feed (CLERK+) and aggregate summary (MERCHANT_ADMIN+), tabbed on one screen. */
    reports: {
        main: '/reports',
    },
    user: {
        userDetail: `/user/:username`,
    },
    transaction: {
        main: `/transaction/:id`,
    },
};

export default Routes;
